import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import { useMemo, useEffect } from "react";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "../config/languages";

const LegalPages = () => {
    const { i18n } = useTranslation("global");
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const urlLang = searchParams.get("lang");

    const pageType = useMemo(() => {
        if (pathname.includes("policy-notes")) return "policy";
        return "terms";
    }, [pathname]);

    const lang = useMemo(() => {
        // Priority: URL query parameter > i18n language > default
        if (urlLang && SUPPORTED_LANGUAGES.includes(urlLang.toLowerCase())) {
            return urlLang.toLowerCase();
        }
        
        const currentLang = (i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE).toLowerCase();
        // Find the best match from supported languages
        const matchedLang = SUPPORTED_LANGUAGES.find(supportedLang => 
            currentLang.startsWith(supportedLang)
        );
        
        return matchedLang || DEFAULT_LANGUAGE;
    }, [urlLang, i18n.resolvedLanguage, i18n.language]);

    // Change the language in i18n when accessed via URL
    useEffect(() => {
        if (urlLang && SUPPORTED_LANGUAGES.includes(urlLang.toLowerCase()) && urlLang !== i18n.language) {
            i18n.changeLanguage(urlLang);
        }
    }, [urlLang, i18n]);

    const fileName = useMemo(() => {
        const files = {
          terms: `legal/${lang}/terms-and-conditions.html`,
          policy: `legal/${lang}/policy-notes.html`,
        };
        return files[pageType] || files.terms;
      }, [pageType, lang]);
      
      return (
        <iframe
          key={fileName}
          src={`/${fileName}`}
          title={pageType === "terms" ? "Terms and Conditions" : "Policy Notes"}
          loading="lazy"
          style={{
            width: "100%",
            height: "100dvh",
            border: "none",
            backgroundColor: "#FFF8E8",
          }}
        />
      );
};

export default LegalPages;